import { Injectable } from '@angular/core';
import {
  AccessibleClientsForUserDto,
  UserClientAccessScopeState,
} from '../../models/card-quota/user-client-access.model';

@Injectable({ providedIn: 'root' })
export class MapperUserClientAccessService {
  mapAccessibleClients(dto: AccessibleClientsForUserDto): UserClientAccessScopeState {
    const raw = dto as AccessibleClientsForUserDto & Record<string, unknown>;
    const scope = dto.scope ?? dto.Scope;
    const scopeRaw = (scope ?? {}) as Record<string, unknown>;
    const clientRows = (dto.clients ?? dto.Clients ?? raw['Clients'] ?? []) as Array<
      Record<string, unknown>
    >;

    const clientIdsRaw = (scopeRaw['clientIds'] ?? scopeRaw['ClientIds'] ?? []) as number[];
    const isRestricted = Boolean(scopeRaw['isRestricted'] ?? scopeRaw['IsRestricted'] ?? false);

    return {
      isRestricted,
      clientIds: clientIdsRaw.map((id) => Number(id)).filter((id) => id > 0),
      clients: clientRows
        .map((row) => ({
          id: Number(row['id'] ?? row['Id'] ?? 0),
          name: String(row['name'] ?? row['Name'] ?? ''),
        }))
        .filter((c) => c.id > 0),
    };
  }
}
